import { convertUrlToParamsObject } from '@/helpers/props';
import { getFilteredH1, mainQueryLength } from '../../reusable/utils/Utils';
export const provinceWithFilters = ({
  queryParams,
  province,
  href,
  data
}) => {
  const mainH1 = getFilteredH1({
    queries: queryParams,
    city: null,
    province,
    data,
    village: ''
  });
  const itemListElement = [{
    '@type': 'ListItem',
    position: 1,
    name: 'شب',
    item: 'https://www.shab.ir'
  }, {
    '@type': 'ListItem',
    position: 2,
    name: `اجاره ویلا در استان ${province}`,
    item: `https://www.shab.ir/search/province/${province}`
  }];
  if (href) {
    itemListElement.push({
      '@type': 'ListItem',
      position: 3,
      name: mainH1?.replace(/"/g, '\\"'),
      item: href
    });
  }
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement
  };
};
export const cityWithFilters = ({
  queryParams,
  city,
  href,
  province,
  data
}) => {
  // const type = getFilteredText(queryParams)
  const mainH1 = getFilteredH1({
    queries: queryParams,
    city,
    province: '',
    data,
    village: ''
  });
  const itemListElement = [{
    '@type': 'ListItem',
    position: 1,
    name: 'شب',
    item: 'https://www.shab.ir'
  }, {
    '@type': 'ListItem',
    position: 2,
    name: `اجاره ویلا در استان ${province}`,
    item: `https://www.shab.ir/search/province/${province}`
  }, {
    '@type': 'ListItem',
    position: 3,
    name: `اجاره ویلا در ${city}`,
    item: `https://www.shab.ir/search/city/${city}`
  }];
  if (href && mainQueryLength(queryParams) <= 1) {
    if (queryParams.mid_term && city === 'تهران') {
      itemListElement.push({
        '@type': 'ListItem',
        position: 4,
        name: 'اجاره ماهانه خانه و آپارتمان مبله در تهران',
        item: `https://www.shab.ir/search/city/تهران?mid_term=1`
      });
    } else {
      itemListElement.push({
        '@type': 'ListItem',
        position: 4,
        name: mainH1?.replace(/"/g, '\\"'),
        item: href
      });
    }
  }
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement
  };
};
export const defaultFilters = ({
  href,
  data
}) => {
  const mainH1 = getFilteredH1({
    queries: convertUrlToParamsObject(href),
    city: null,
    province: null,
    data,
    village: ''
  });
  if (href === 'https://www.shab.ir/search?cottage=1') {
    href = 'https://www.shab.ir/all-cottage';
  }
  if (href === 'https://www.shab.ir/search?boomgardi=1') {
    href = 'https://www.shab.ir/all-boomgardi';
  }
  const itemListElement = [{
    '@type': 'ListItem',
    position: 1,
    name: 'شب',
    item: 'https://www.shab.ir'
  }];
  if (href?.includes('parent_id')) {
    itemListElement.push({
      '@type': 'ListItem',
      position: 2,
      name: `اجاره ویلا در استان ${data?.parent?.province}`,
      item: `https://www.shab.ir/search/province/${data?.parent?.province}`
    });
    itemListElement.push({
      '@type': 'ListItem',
      position: 3,
      name: `اجاره ویلا در ${data?.parent?.city}`,
      item: `https://www.shab.ir/search/city/${data?.parent?.city}`
    });
    itemListElement.push({
      '@type': 'ListItem',
      position: 4,
      name: data?.parent?.title?.replace(/"/g, '\\"'),
      item: `https://www.shab.ir/search?parent_id=${convertUrlToParamsObject(href).parent_id}`
    });
  } else if (href?.includes('villa=1')) {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement
    };
  } else if (href?.includes('swiss-cottage=1')) {
    itemListElement.push({
      '@type': 'ListItem',
      position: 2,
      name: `اجاره کلبه چوبی و جنگلی`,
      item: `https://www.shab.ir/all-cottage`
    }, {
      '@type': 'ListItem',
      position: 3,
      name: `اجاره کلبه سوئیسی`,
      item: `https://www.shab.ir/search?swiss-cottage=1`
    });
  } else {
    itemListElement.push({
      '@type': 'ListItem',
      position: 2,
      name: mainH1?.replace(/"/g, '\\"'),
      item: href
    });
  }
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement
  };
};
export const nearCitiesFilters = ({
  city
}) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      name: 'شب',
      item: 'https://www.shab.ir'
    }, {
      '@type': 'ListItem',
      position: 2,
      name: `اجاره ویلا و سوئیت اطراف ${city}`,
      item: `https://www.shab.ir/search?near_cities=${city}`
    }]
  };
};
export const placeFilters = ({
  queryParams,
  placeName
}) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      name: 'شب',
      item: 'https://www.shab.ir'
    }, {
      '@type': 'ListItem',
      position: 2,
      name: 'اجاره ویلا و سوئیت در استان تهران',
      item: 'https://www.shab.ir/search/province/تهران'
    }, {
      '@type': 'ListItem',
      position: 3,
      name: 'اجاره ویلا و سوئیت در تهران',
      item: 'https://www.shab.ir/search/city/تهران'
    }, {
      '@type': 'ListItem',
      position: 4,
      name: `اجاره روزانه خانه و سوئیت در ${placeName} تهران`,
      item: `https://www.shab.ir/search/city/تهران?${queryParams.place_id ? 'place_id' : 'tag'}=${queryParams.place_id || queryParams.tag}`
    }]
  };
};
export const villageFilters = ({
  village,
  data
}) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      name: 'شب',
      item: 'https://www.shab.ir'
    }, {
      '@type': 'ListItem',
      position: 2,
      name: `اجاره ویلا در استان ${data.region_data?.province}`,
      item: `https://www.shab.ir/search/province/${data.region_data?.province}`
    }, {
      '@type': 'ListItem',
      position: 3,
      name: `اجاره ویلا در ${data.region_data?.city}`,
      item: `https://www.shab.ir/search/city/${data.region_data?.city}`
    }, {
      '@type': 'ListItem',
      position: 4,
      name: `اجاره ویلا در ${village}`,
      item: `https://www.shab.ir/search/village/${village}`
    }]
  };
};